import React, { useState, useEffect } from 'react';
import { productAPI } from '../../Handlers/productAPI';
import { adminCategoryAPI } from '../../../Handlers/categoryAPI'; // Importado para buscar as opções do filtro
import styles from '../../styles/ShowTables/product/ProductList.module.css';

import CreateProductModal from '../../components/modals/createModal';
import ProductForm from '../../components/forms/productForm';
import ProductCard from '../../components/cards/productCard';
import EditProductForm from '../../components/forms/EditProductForm';

function ProductList() {
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]); // Estado para as categorias do filtro
    const [selectedCategory, setSelectedCategory] = useState(''); // Estado do filtro selecionado
    
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [productToEdit, setProductToEdit] = useState(null);

    // Busca produtos e categorias
    const fetchData = async () => {
        try {
            const [prodRes, catRes] = await Promise.all([
                productAPI.getAll(),
                adminCategoryAPI.list()
            ]);

            const cleanProds = Array.isArray(prodRes) ? prodRes : (prodRes.products || []);
            setProducts(cleanProds);
            setCategories(catRes || []);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
        }
    };

    useEffect(() => { fetchData(); }, []);

    const refreshList = () => {
        fetchData();
        setShowCreateModal(false);
        setShowEditModal(false);
        setProductToEdit(null);
    };

    const onEdit = (product) => {
        setProductToEdit(product);
        setShowEditModal(true);
    };

    const onDelete = async (id) => {
        if (window.confirm("Deseja realmente desativar este produto?")) {
            try {
                await productAPI.delete(id);
                setProducts(prev => prev.filter(p => (p.id || p.product?.id) !== id));
            } catch (error) { alert("Erro ao desativar o produto."); }
        }
    };

    // Lógica de Filtragem: A "Lei" que decide quem aparece no grid
    const filteredProducts = products.filter(p => {
        const prod = p.product || p;
        if (!selectedCategory) return true; // Se não houver filtro, mostra tudo
        return String(prod.category_id) === String(selectedCategory);
    });

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1 className={styles.title}>Gerenciar Produtos</h1>
                
                <div className={styles.actions}>
                    {/* Botão de Filtro Estilizado */}
                    <div className={styles.filterWrapper}>
                        <span className={styles.filterLabel}>Filtrar:</span>
                        <select 
                            className={styles.filterSelect}
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                        >
                            <option value="">Todas as Categorias</option>
                            {categories.map(cat => (
                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                            ))}
                        </select>
                    </div>

                    <button className={styles.addButton} onClick={() => setShowCreateModal(true)}>
                        + Novo Produto
                    </button>
                </div>
            </div>

            <div className={styles.grid}>
                {filteredProducts.length > 0 ? (
                    filteredProducts.map(p => (
                        <ProductCard
                            key={p.id || p.product?.id}
                            product={p.product || p}
                            onDelete={onDelete}
                            onEdit={onEdit}
                        />
                    ))
                ) : (
                    <div className={styles.noResults}>
                        Nenhum produto encontrado nesta categoria.
                    </div>
                )}
            </div>

            {/* MODAL DE CRIAÇÃO */}
            {showCreateModal && (
                <CreateProductModal 
                    isOpen={showCreateModal} 
                    onClose={() => setShowCreateModal(false)}
                    title="Cadastrar Produto"
                >
                    <ProductForm onSuccess={refreshList} />
                </CreateProductModal>
            )}

            {/* MODAL DE EDIÇÃO */}
            {showEditModal && productToEdit && (
                <CreateProductModal 
                    isOpen={showEditModal} 
                    onClose={() => setShowEditModal(false)}
                    title="Editar Produto"
                >
                    <EditProductForm 
                        product={productToEdit} 
                        onSuccess={refreshList} 
                    />
                </CreateProductModal>
            )}
        </div>
    );
}

export default ProductList;